import { render, staticRenderFns } from "./TabGaleriaDeRDs.vue?vue&type=template&id=33dea2c0"
import script from "./TabGaleriaDeRDs.vue?vue&type=script&lang=ts"
export * from "./TabGaleriaDeRDs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports